import type { RequestDataValue } from '../../../../../../context/RequestDataContext';

/**
 * `master` scopes the reference fetch to the subset under a master row. Only an
 * edit form may do that — its request data describes the very record the
 * reference belongs to. A filter scope's request data describes the filtered
 * (slave) dataset instead, so its master row must not leak into a query against
 * the unrelated reference dataset.
 */
export const getReferenceMasterScope = (
  requestData: RequestDataValue | undefined,
  isFormInput: boolean
): { id: string; idItem: string } | undefined => {
  if (!isFormInput || !requestData || !('master' in requestData)) {
    return undefined;
  }

  return requestData.master;
};
